<template>
  <div id="app">
    <notifications classes="notification" position="bottom right" width="21vw"/>
    <navbar :iconLength="navbarLinkLen" v-if="noNavbars.indexOf($route.name) === -1"></navbar>
    <div class="router">
      <navbar-link
        class="navbar-link"
        :menu="menu"
        v-model="navbarLinkLen"
        v-if="noNavbars.indexOf($route.name) === -1"
      ></navbar-link>
      <router-view class="router-view"/>
    </div>
  </div>
</template>

<script>
import axios from '@/axios'
import store from './store'

export default {
  data() {
    return {
      noNavbars: ['Login', 'Logout'],
      navbarLinkLen: 0,
      menu: [
        {
          icon: 'tachometer-alt',
          text: 'dashboard',
          path: '/'
        }, {
          icon: 'project-diagram',
          text: 'flow',
          path: '/flow'
        }, {
          icon: 'paperclip',
          text: 'attachments',
          path: '/attachments'
        }, {
          icon: 'comments',
          text: 'livechat',
          path: '/livechat'
        }, {
          icon: 'users',
          text: 'users',
          path: '/users'
        }, {
          icon: 'users-cog',
          text: 'admins',
          path: '/admins'
        }, {
          icon: 'cogs',
          text: 'settings',
          path: '/settings'
        }
      ]
    }
  },

  async mounted() {
    await this.delayMs(5000)
    this.refreshToken()
    let that = this
    setInterval(function () {
      that.refreshToken()
    }, 10 * 60 * 1000)
  },

  async created() {
    try {
      const isIp = /^(?=.*[^\.]$)((25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.?){4}$/gmi.test(window.location.hostname)
      if (!isIp && window.location.hostname !== 'localhost' && window.location.protocol !== 'https:') window.location.protocol = 'https:'
      if (!window.localStorage.getItem('user')) return
      await this.loadGlobalNeededStoreData()
    } catch (e) {
      console.error(e)
    }
  },

  methods: {
    async refreshToken() {
      try {
        const userData = JSON.parse(localStorage.getItem('user'))
        if (!userData) return
        const req = await axios.get('/api/auth/refresh')
        localStorage.setItem('tokenExp', +new Date(req.data.expires))
      } catch (e) {
        console.error(e)
      }
    },
    async loadGlobalNeededStoreData() {
      try {
        this.$store.dispatch('loadUsersGroups')
        this.$store.dispatch('loadAttachments')
        this.$store.dispatch('loadVersion')
      } catch (e) {
        throw e
      }
    }
  }
}
</script>

<style lang="scss">
@import "~@csstools/normalize.css";
@import url("https://fonts.googleapis.com/css?family=Work+Sans:400,500,600|Lato:300,400,400i,700&display=swap&subset=latin-ext");

html {
  height: 100%;
}

body {
  margin: 0;
  height: 100%;
  overflow-y: hidden;
}

#app {
  font-family: "Lato";
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow-y: hidden;
  max-width: 100vw;
}

.router {
  flex-grow: 1;
  display: flex;
  max-width: 100%;
  overflow: auto;
}

.navbar-link-toggle {
  display: flex;
  align-items: center;
}

.icon-toggle {
  font-size: 3em;
  padding: 8px 6px 8px 10px;
}

.router-view {
  background-color: $bgGrey;
  flex-grow: 1;
  overflow: auto;
}

.router {
  max-width: 100%;
}

.editor {
  padding: 0px 0px 0px 26px;
  flex-grow: 1;
  height: calc(100vh - 58px);
  overflow-x: hidden;
}

.editor-section {
  padding-left: 8px;
}

.editor-section-description {
  margin-bottom: 16px;

  &--important {
    font-weight: 700;
    font-style: italic;
    color: $danger;
  }
}

.popper {
  box-shadow: 0px 0px 17px -8px rgba(0, 0, 0, 0.25) !important;
  background-color: white !important;
  padding: 10px 12px 14px 12px !important;
  border-radius: 7px !important;
  transform: translateZ(0px);
}

.notification {
  .notification-title {
    font-family: "Work Sans";
    font-weight: 500;
    font-size: 1.4em;
    margin-bottom: 4px;
  }

  .notification-content {
    font-family: "Lato";
    font-size: 1.1em;
    white-space: pre-wrap;
  }

  padding: 10px;
  margin: 0 5px 5px;

  font-size: 12px;

  color: #ffffff;
  background: #44a4fc;
  border-left: 5px solid #187fe7;

  &.warn {
    background: #ffb648;
    border-left-color: #f48a06;
  }

  &.error {
    background: #e54d42;
    border-left-color: #b82e24;
  }

  &.success {
    background: #68cd86;
    border-left-color: #42a85f;
  }
}

.echarts {
  width: 100% !important;
}

::-webkit-scrollbar {
  width: 2px;
  height: 2px;
}

::-webkit-scrollbar-track {
  background: #f1f1f1;
}

::-webkit-scrollbar-thumb {
  background: #888;
}

::-webkit-scrollbar-thumb:hover {
  background: #555;
}
</style>
